"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevels = void 0;
var LogLevels;
(function (LogLevels) {
    /** 0 */ LogLevels[LogLevels["ERROR"] = 0] = "ERROR";
    /** 1 */ LogLevels[LogLevels["WARN"] = 1] = "WARN";
    /** 2 */ LogLevels[LogLevels["DEBUG"] = 2] = "DEBUG";
    /** 3 */ LogLevels[LogLevels["INFO"] = 3] = "INFO";
})(LogLevels = exports.LogLevels || (exports.LogLevels = {}));
